module.exports = __webpack_public_path__ + "img/wm2026_de.18ba558d.png";